
export class chofer_sucursalJoin {
	public rut: number;
	public sucursal_codigo: number;
	public rut_empresa: number;
	public fecha_asignacion: Date;
	public estado: boolean;
	public nombre:string;
	public fono1:string;
	public fono2:string;
	public fecha_creacion:Date;
	public es_cliente:boolean;
	public rut_antiguo:number;
}
